module.exports = " <div class=actionsheet-wrapper> <div class=mask v-show=visible></div> <div class=actionsheet v-show=visible> <div class=tips>{{tips}}</div> <button @click=\"handleActions('confirm')\" class=\"btn bottom\">{{btn}}</button> <button @click=\"handleActions('del')\" class=\"btn warning\">{{del}}</button> <button @click=\"handleActions('cancel')\" class=\"btn bottom\">{{cancel}}</button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actionsheet.vue
// module id = 117
// module chunks = 1